import { PASSWORD_POLICY_MESSAGE } from "../authFieldPolicy";

export const SIGNUP_UI = {
  title: "Complete your account setup",
  subtitle:
    "Finish setting up secure access to WaterMinds. All fields are required.",
  submitLabel: "Accept invite",
  submittingLabel: "Accepting invite…",
  // smsConsentLabel:
  //   "By providing your mobile number and checking this box you consent to receiving text messages from Inframark WaterMinds. Message and data rates may apply. Reply HELP for help. Reply STOP to unsubscribe. One message per verification.",
  successBannerTitle: "Account ready",
  successBody:
    "Your account is set up. Redirecting you to sign in…",
  validatingMessage: "Validating your invitation…",
  sessionCheckMessage: "Checking your session…",
  activeSessionTitle: "Sign out required",
  activeSessionMessage:
    "You are currently signed in to WaterMinds. Sign out to continue with this invitation.",
  logoutLabel: "Sign out and continue",
  loggingOutLabel: "Signing out…",
  inviteExpiredTitle: "Invitation Expired",
  inviteExpiredMessage:
    "This invitation link has expired or is no longer valid. Please contact your administrator to request a new invitation.",
  submitErrorMessage: "Unable to accept your invite. Please try again.",
  phoneAlreadyExistsError:
    "This phone number is already in use. Try another one.",
  phoneValidateFailedError: "Failed to validate phone number. Please try again.",
  signupFields: [
    {
      name: "email",
      label: "Email",
      type: "text",
      disabled: true,
    },
    {
      name: "phoneNumber",
      label: "Phone number",
      placeholder: "Phone number",
      type: "phone",
      compact: true,
      required: true,
      country: "us",
    },
    {
      name: "firstName",
      label: "First name",
      type: "text",
      required: true,
      validation: { maxLength: 50 },
    },
    {
      name: "lastName",
      label: "Last name",
      type: "text",
      required: true,
      validation: { maxLength: 75 },
    },
    {
      name: "password",
      label: "Password",
      type: "password",
      required: true,
      info: PASSWORD_POLICY_MESSAGE,
      showPasswordToggle: true,
    },
    {
      name: "confirmPassword",
      label: "Confirm password",
      type: "password",
      required: true,
      info: "Re-enter the same password.",
      showPasswordToggle: true,
    },
    {
      name: "acceptedTerms",
      type: "checkbox",
      authConsent: true,
      label:
        "By providing your mobile number and checking this box you consent to receiving one-time passcodes via text message at the number provided for multi-factor authentication from Azuria Water Solutions Inc. Standard message and data rates may apply. Reply HELP for help. Reply STOP to opt out. One message per login attempt. For more information, see our Terms & Privacy Policy.",
      required: true,
    },
  ],
};
